import di from 'di'

import first from 'lodash/first'

import { i18n as coreMessages } from '@wittignl/js-core'

import { createI18n } from 'vue-i18n'
import { Settings } from 'luxon'

export default function(app){

    const config = di.get('config');

    // Auto-select language
    const language = config.i18n.language;
    const messages = coreMessages

    // I18n
    const i18n = createI18n({
        locale: language,
        fallbackLocale: language,
        messages,
    });

    // Luxon
    Settings.defaultLocale = language;

    di.set('i18n', i18n);
    app.use(i18n);
}